import { BaseDialogBehavior } from 'App/Services/DialogService/BaseDialogBehavior';
import { Component } from 'Framework/Components/UIElement';
import urlJoin from 'url-join';

interface IPrsState {
    baseUriPrs: string;
    workshopName: string;
    localName: string;
}

@Component({
    name: 'OranoPrsDialog'
})
export default class OranoPrsDialog extends BaseDialogBehavior<IPrsState> {
    public get uriPrs(): string {
        if (!this._dataContext) {
            return '';
        }

        return urlJoin(this._dataContext.baseUriPrs, `/#/sva/${this._dataContext.workshopName}/${this._dataContext.localName}`).replace('#', '/#');
    }
}
